import EventEmitter from "base/EventEmitter";

export default class FieldEditor extends EventEmitter {
    /**
     * @param $element
     * @param settings
     */
    constructor($element, settings = {}) {
        super();
        this.$element = $element;
        this.$element.data("editor", this);
        this.settings = $.extend(true, {}, this.getDefaultSettings(), settings);
    }

    /**
     * Create and show the editor element(s)
     *
     * @abstract
     */
    create() {
        throw new TypeError("Field editor must override \"create\" method");
    }

    focus() {
        //Noop
    }

    valid() {
        return true;
    }

    /**
     * Hide and destroy the editor element(s)
     *
     * @abstract
     */
    destroy() {
        super.destroy();
    }

    /**
     * @abstract
     * @return string
     */
    getValue() {
        throw new TypeError("Field editor must override \"getValue\" method");
    }

    /**
     * @param value mixed
     * @abstract
     */
    setValue(value) {
        throw new TypeError("Field editor must override \"setValue\" method");
    }

    getDefaultSettings() {
        return {};
    }

    static register_editor(name, clazz) {
        if (!FieldEditor.editors) {
            FieldEditor.editors = {};
        }
        FieldEditor.editors[name] = clazz;
    }

    /**
     * @param type
     * @param $element
     * @param settings
     * @param create
     *
     * @return FieldEditor
     */
    static get_editor(type, $element, settings = {}, create = true) {
        if (!FieldEditor.editors) {
            throw Error("No field editors defined");
        }

        if ("undefined" === typeof FieldEditor.editors[type]) throw Error("Invalid editor type " + type);

        if ($element.length === 0) {
            throw Error("Tried to attach a field editor to a missing element");
        }

        let editor = new FieldEditor.editors[type]($element, settings);
        editor.editorType = type;

        if (create) {
            editor.create();
        }

        return editor;
    }
}
